import { Injectable } from '@angular/core';
import { ConfigService } from '../../common/services/config.service';
import { HttpInterceptor } from '../../common/services/httpInterceptor.service';
import { SessionHandlerService } from './../../common/services/sessionHandler.service';
import { CommonConstants } from './../../common/utilities/commonConstants';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
@Injectable()

export class MoreAboutYouCall {
    private notify = new Subject<any>();
    notifyObservable$ = this.notify.asObservable();
    constructor(
        private _httpinterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
        private _http: HttpClient
    ) { }

    public PostCallService(data, currentTaskKey, productCode?: any, principalCode?: any) {
        const url = this.createURL(currentTaskKey, productCode, principalCode, true);
        return this._httpinterceptor.Post(url, data);
    }
    public GetCallService(nextTaskKey?: any, productCode?: any, principalCode?: any, PastPersonal?) {
        const url = this.createURL(nextTaskKey, productCode, principalCode, false, PastPersonal);
        return this._httpinterceptor.Get(url);
    }
    public createURL(taskKey, productCode, principalCode, IsPost?: boolean, pastPersonalParam?) {
        let controlName: any;
        const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
        const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const NomineeID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.NomineeID);
        let questionSetCode;
        questionSetCode =
            taskKey === 'questionnaireDetails' ?
                (CommonConstants.productCode.includes(productCode)) ? CommonConstants.QuestionSetCode[productCode] : CommonConstants.QuestionSetCode[principalCode]
                : pastPersonalParam ? CommonConstants.QuestionSetCode['MAXBUPHCOMPASTPROPOSAL'] : this.nextQuestionsPage(taskKey, productCode);
        switch (taskKey) {
            case 'permanentAddressDetails':
                controlName = ConfigService.getInstance().getConfigObject().APIURL.mailingAddressService;
                controlName = controlName.replace('{applicationId}', applicationId);
                controlName = controlName.replace('{quoteId}', quoteId);
                controlName = controlName.replace('{addressCode}', '1');
                break;
            case 'additionalAddressDetails':
                controlName = ConfigService.getInstance().getConfigObject().APIURL.mailingAddressService;
                controlName = controlName.replace('{applicationId}', applicationId);
                controlName = controlName.replace('{quoteId}', quoteId);
                controlName = controlName.replace('{addressCode}', '5');
                break;
            case 'nomineeDetails':
                controlName = ConfigService.getInstance().getConfigObject().APIURL.nomineesService;
                controlName = controlName.replace('{applicationId}', applicationId);
                controlName = controlName.replace('{quoteId}', quoteId ? quoteId : 0);
                controlName = controlName.replace('{nomineeId}', NomineeID ? NomineeID : null);
                break;
            case 'questionnaireDetails':
            case 'femaleRelatedQuestions':
            case 'pastRelatedQuestions':
            case 'lifestyleDetails':
                const api = CommonConstants.insuredLvlQuestionairre.includes(principalCode) && productCode !== 'BAGICIGHP2' && productCode !== 'BAGICFGHP2' && !IsPost ? 'medicalDeclarationABHIService' : 'medicalDeclarationService';
                controlName = ConfigService.getInstance().getConfigObject().APIURL[api];
                controlName = controlName.replace('{applicationId}', applicationId);
                controlName = controlName.replace('{quoteId}', quoteId);
                controlName = controlName.replace('{productCode}', productCode);
                controlName = controlName.replace('{questionSetCode}', questionSetCode);
                break;
        }
        return controlName;
    }
    public nextQuestionsPage(taskKey, productCode) {
        let questionSetCode;
        switch (taskKey) {
            case 'lifestyleDetails':
                questionSetCode = CommonConstants.QuestionSetCode[productCode + 'LIFESTYLE'];
                break;
            case 'femaleRelatedQuestions':
                questionSetCode = CommonConstants.QuestionSetCode[productCode + 'FEMALE'];
                break;
            case 'pastRelatedQuestions':
                questionSetCode = CommonConstants.QuestionSetCode[productCode + 'PASTPROPOSAL'];
                break;
        }
        return questionSetCode;
    }
    public showSummary() {
        // to uncomment for actual integration
        let controlName;
        const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
        const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        controlName = ConfigService.getInstance().getConfigObject().APIURL.getSummaryDetails;
        controlName = controlName.replace('{applicationId}', applicationId);
        controlName = controlName.replace('{quoteId}', quoteId);
        const url = controlName;
        return this._httpinterceptor.Get(url);
    }
    public GetHomeArea(cityId: number) {
        const url = ConfigService.getInstance().getConfigObject()
            .APIURL.getGeoLocationBasedOnCityId.replace('{0}', cityId.toString());
        return this._httpinterceptor.Get(url);
    }

    public getMockResponse(nextTaskKey?: any) {
        let mockJSON: any;
        switch (nextTaskKey) {
            case 'permanentAddressDetails':
                mockJSON = this._http.get('assets/MockJson/hrMailingAddress.json');
                break;
            case 'nomineeDetails':
                mockJSON = this._http.get('assets/MockJson/hrNomineeDetails.json');
                break;
            case 'questionnaireDetails':
                mockJSON = this._http.get('assets/MockJson/medicalDeclaration-get.json');
                break;
        }
        return mockJSON;
    }
    public postMockResponse(nextTaskKey?: any) {
        let mockJSON: any;
        switch (nextTaskKey) {
            case 'permanentAddressDetails':
                mockJSON = this._http.get('assets/MockJson/hrMailingAddress-post.json');
                break;
            case 'nomineeDetails':
                mockJSON = this._http.get('assets/MockJson/hrNomineeDetails-post.json');
                break;
            case 'questionnaireDetails':
                mockJSON = this._http.get('assets/MockJson/medicalDeclaration-get.json');
                break;
        }
        return mockJSON;
    }
    public backMockResponse(nextTaskKey?: any) {
        let mockJSON: any;
        switch (nextTaskKey) {
            case 'permanentAddressDetails':
                mockJSON = this._http.get('assets/MockJson/hrMailingAddress-post.json');
                break;
            case 'nomineeDetails':
                mockJSON = this._http.get('assets/MockJson/hrNomineeDetails-back.json');
                break;
            case 'questionnaireDetails':
                mockJSON = this._http.get('assets/MockJson/medicalDeclaration-back.json');
                break;
        }
        return mockJSON;
    }
    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }
}
